module.exports = __webpack_public_path__ + "img/1x.ef9fb66.jpg";